// extracted by mini-css-extract-plugin
export var blogItem = "posts-section-module--blog-item--vJKqA";
export var blogList = "posts-section-module--blog-list--sm7-4";
export var buttonContainer = "posts-section-module--button-container--aBemQ";
export var promotedPostsSection = "posts-section-module--promoted-posts-section--OGavL";
export var title = "posts-section-module--title--EPVk1";